import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";
import logo from "../../../assets/images/logo.svg";
import MobileNavbar from "./MobileNavbar";
import ServicesDropDown from "./ServicesDropDown";
import IndustryDropdown from "./IndustryDropdown";

const NAV_ITEMS = [
    { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/mobility", label: "Industries" },
  { to: "/insights", label: "Insights" },
  { to: "/work", label: "Work" },
  { to: "/careers", label: "Careers" },

];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [industryDropdownOpen, setIndustryDropdownOpen] = useState(false);
  const servicesCloseTimerRef = useRef(null);
  const industryCloseTimerRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    if (menuOpen) {
      document.addEventListener("keydown", onKeyDown);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    return () => {
      if (servicesCloseTimerRef.current) {
        clearTimeout(servicesCloseTimerRef.current);
      }
      if (industryCloseTimerRef.current) {
        clearTimeout(industryCloseTimerRef.current);
      }
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const openServicesDropdown = () => {
    if (servicesCloseTimerRef.current) {
      clearTimeout(servicesCloseTimerRef.current);
      servicesCloseTimerRef.current = null;
    }
    setIndustryDropdownOpen(false);
    setServicesDropdownOpen(true);
  };

  const queueCloseServicesDropdown = () => {
    if (servicesCloseTimerRef.current) {
      clearTimeout(servicesCloseTimerRef.current);
    }
    servicesCloseTimerRef.current = setTimeout(() => {
      setServicesDropdownOpen(false);
      servicesCloseTimerRef.current = null;
    }, 120);
  };

  const openIndustryDropdown = () => {
    if (industryCloseTimerRef.current) {
      clearTimeout(industryCloseTimerRef.current);
      industryCloseTimerRef.current = null;
    }
    setServicesDropdownOpen(false);
    setIndustryDropdownOpen(true);
  };

  const queueCloseIndustryDropdown = () => {
    if (industryCloseTimerRef.current) {
      clearTimeout(industryCloseTimerRef.current);
    }
    industryCloseTimerRef.current = setTimeout(() => {
      setIndustryDropdownOpen(false);
      industryCloseTimerRef.current = null;
    }, 120);
  };

  const renderDesktopLinks = () =>
    NAV_ITEMS.map(({ to, label }) => {
      if (to !== "/services" && to !== "/mobility") {
        return (
          <NavLink
            key={to}
            to={to}
            onClick={closeMenu}
            className={({ isActive }) =>
              `navbar-desktop-nav__link${isActive ? " navbar-desktop-nav__link--active" : ""}`
            }
          >
            {label}
          </NavLink>
        );
      }

      return (
        <div
          key={to}
          className="navbar-desktop-nav__services-item"
          onMouseEnter={to === "/services" ? openServicesDropdown : openIndustryDropdown}
          onMouseLeave={
            to === "/services"
              ? queueCloseServicesDropdown
              : queueCloseIndustryDropdown
          }
        >
          <NavLink
            to={to}
            onClick={(e) => {
              if (to === "/mobility") {
                e.preventDefault();
                return;
              }
              closeMenu();
            }}
            className={({ isActive }) =>
              `navbar-desktop-nav__link${isActive ? " navbar-desktop-nav__link--active" : ""}`
            }
          >
            {label}
          </NavLink>
          
        </div>
      );
    });

  return (
    <>
      <header className="navbar">
        <div className="navbar-container">
          <Link className="logo" to="/" onClick={closeMenu}>
            <img src={logo} alt="logo" />
          </Link>

          <button
            type="button"
            className={`navbar-burger ${menuOpen ? "navbar-burger--open" : ""}`}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="navbar-mobile-panel"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span className="navbar-burger__bar" aria-hidden />
            <span className="navbar-burger__bar" aria-hidden />
            <span className="navbar-burger__bar" aria-hidden />
          </button>

          <nav className="navbar-desktop-nav" aria-label="Main">
            {renderDesktopLinks()}
            <Link to="/contact" className="contact-btn contact-btn--desktop">
              Contact us
            </Link>
          </nav>
        </div>
        {servicesDropdownOpen && (
          <div
            onMouseEnter={openServicesDropdown}
            onMouseLeave={queueCloseServicesDropdown}
          >
            <ServicesDropDown />
          </div>
        )}
        {industryDropdownOpen && (
          <div
            onMouseEnter={openIndustryDropdown}
            onMouseLeave={queueCloseIndustryDropdown}
          >
            <IndustryDropdown />
          </div>
        )}
      </header>

      <MobileNavbar menuOpen={menuOpen} closeMenu={closeMenu} logo={logo} />
      
    </>
  );
};

export default Navbar;
